/**
 * 消費税まわりの共通ユーティリティ。
 *
 * 新DB（4 バケット残高・contract_amount）は税抜で保持し、表示・振込時にここで
 * 税込変換する方針。税率が変わった場合はこの定数のみ更新すればよい
 * （軽減税率・非課税は現状非対応で、BE の `app/tax.py` の税率と揃えている）。
 */

/** 消費税率（10%）。BE の `app/tax.py` CONSUMPTION_TAX_RATE と一致させる。 */
export const CONSUMPTION_TAX_RATE = 0.1;

/**
 * 税抜金額を税込金額（円・整数）に変換する。
 * 端数は四捨五入して整数円にする（表示・申請の一貫性のため）。
 * 非有限値は 0 を返す。
 */
export const addConsumptionTax = (amountExclusive: number): number => {
  if (!Number.isFinite(amountExclusive)) return 0;
  return Math.round(amountExclusive * (1 + CONSUMPTION_TAX_RATE));
};
